/**
 * @fileoverview gRPC-Web generated client stub for accountpb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.14.0
// source: proto/accountpb/correspondent.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')
const proto = {};
proto.accountpb = require('./correspondent_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.accountpb.CorrespondentServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.accountpb.CorrespondentServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountpb.ReadCorrespondentRequest,
 *   !proto.accountpb.ReadCorrespondentResponse>}
 */
const methodDescriptor_CorrespondentService_ReadCorrespondent = new grpc.web.MethodDescriptor(
  '/accountpb.CorrespondentService/ReadCorrespondent',
  grpc.web.MethodType.UNARY,
  proto.accountpb.ReadCorrespondentRequest,
  proto.accountpb.ReadCorrespondentResponse,
  /**
   * @param {!proto.accountpb.ReadCorrespondentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.ReadCorrespondentResponse.deserializeBinary
);


/**
 * @param {!proto.accountpb.ReadCorrespondentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountpb.ReadCorrespondentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountpb.ReadCorrespondentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountpb.CorrespondentServiceClient.prototype.readCorrespondent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountpb.CorrespondentService/ReadCorrespondent',
      request,
      metadata || {},
      methodDescriptor_CorrespondentService_ReadCorrespondent,
      callback);
};


/**
 * @param {!proto.accountpb.ReadCorrespondentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountpb.ReadCorrespondentResponse>}
 *     Promise that resolves to the response
 */
proto.accountpb.CorrespondentServicePromiseClient.prototype.readCorrespondent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountpb.CorrespondentService/ReadCorrespondent',
      request,
      metadata || {},
      methodDescriptor_CorrespondentService_ReadCorrespondent);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountpb.Correspondent,
 *   !proto.accountpb.ReadCorrespondentResponse>}
 */
const methodDescriptor_CorrespondentService_GetSiteDetails = new grpc.web.MethodDescriptor(
  '/accountpb.CorrespondentService/GetSiteDetails',
  grpc.web.MethodType.UNARY,
  proto.accountpb.Correspondent,
  proto.accountpb.ReadCorrespondentResponse,
  /**
   * @param {!proto.accountpb.Correspondent} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.ReadCorrespondentResponse.deserializeBinary
);


/**
 * @param {!proto.accountpb.Correspondent} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountpb.ReadCorrespondentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountpb.ReadCorrespondentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountpb.CorrespondentServiceClient.prototype.getSiteDetails =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountpb.CorrespondentService/GetSiteDetails',
      request,
      metadata || {},
      methodDescriptor_CorrespondentService_GetSiteDetails,
      callback);
};


/**
 * @param {!proto.accountpb.Correspondent} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountpb.ReadCorrespondentResponse>}
 *     Promise that resolves to the response
 */
proto.accountpb.CorrespondentServicePromiseClient.prototype.getSiteDetails =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountpb.CorrespondentService/GetSiteDetails',
      request,
      metadata || {},
      methodDescriptor_CorrespondentService_GetSiteDetails);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.accountpb.ReadCorrespondentResponse>}
 */
const methodDescriptor_CorrespondentService_GetCorrespondentByUrl = new grpc.web.MethodDescriptor(
  '/accountpb.CorrespondentService/GetCorrespondentByUrl',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.accountpb.ReadCorrespondentResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.ReadCorrespondentResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountpb.ReadCorrespondentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountpb.ReadCorrespondentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountpb.CorrespondentServiceClient.prototype.getCorrespondentByUrl =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountpb.CorrespondentService/GetCorrespondentByUrl',
      request,
      metadata || {},
      methodDescriptor_CorrespondentService_GetCorrespondentByUrl,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountpb.ReadCorrespondentResponse>}
 *     Promise that resolves to the response
 */
proto.accountpb.CorrespondentServicePromiseClient.prototype.getCorrespondentByUrl =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountpb.CorrespondentService/GetCorrespondentByUrl',
      request,
      metadata || {},
      methodDescriptor_CorrespondentService_GetCorrespondentByUrl);
};


module.exports = proto.accountpb;

